var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconLeftChevron = function SvgIconLeftChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53 9.78a.75.75 0 0 0 0-1.06L4.81 6l2.72-2.72a.75.75 0 0 0-1.06-1.06L3.22 5.47a.75.75 0 0 0 0 1.06l3.25 3.25a.75.75 0 0 0 1.06 0Z",
    fill: "currentColor"
  })));
};

export { SvgIconLeftChevron as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTIgMTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03LjUzMDMzIDkuNzgwMzNDNy44MjMyMiA5LjQ4NzQ0IDcuODIzMjIgOS4wMTI1NiA3LjUzMDMzIDguNzE5NjdMNC44MTA2NiA2TDcuNTMwMzMgMy4yODAzM0M3LjgyMzIyIDIuOTg3NDQgNy44MjMyMiAyLjUxMjU2IDcuNTMwMzMgMi4yMTk2N0M3LjIzNzQ0IDEuOTI2NzggNi43NjI1NiAxLjkyNjc4IDYuNDY5NjcgMi4yMTk2N0wzLjIxOTY3IDUuNDY5NjdDMi45MjY3OCA1Ljc2MjU2IDIuOTI2NzggNi4yMzc0NCAzLjIxOTY3IDYuNTMwMzNMNi40Njk2NyA5Ljc4MDMzQzYuNzYyNTYgMTAuMDczMiA3LjIzNzQ0IDEwLjA3MzIgNy41MzAzMyA5Ljc4MDMzWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";